<template>
    <div>
        <div class="row">
            <div class="col-12 discipline-buttons text-center">
                <design-2021-digitalstudies-subject-button
                    class="discipline-button"
                    v-for="button in disciplineButtons"
                    :key="button.id"
                    :name="button.id"
                    :style="btnStyle(button)"
                    @selectedDiscipline="showDomains($event, button.color)">
                    <span class="icon">
                        <design-2021-apprentice-inline-svg-component
                            :icon-source="button.icon"
                            :color="button.color"></design-2021-apprentice-inline-svg-component>
                    </span>
                    <span class="discipline-name">{{ button.name }}</span>
                </design-2021-digitalstudies-subject-button>
            </div>
        </div>

        <div
            class="row"
            v-if="loading">
            <div class="col-12 text-center">
                <div
                    class="fa-3x subdomain-loading"
                    :style="loadingStyle()">
                    <i class="fas fa-spinner fa-spin"></i>
                </div>
            </div>
        </div>

        <div class="row row-cols-1 row-cols-md-2">
            <design-2021-digitalstudies-subject-card
                v-for="domain in domains"
                v-bind:showDomain="domain"
                v-if="!loading"
                :key="domain.name"></design-2021-digitalstudies-subject-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-digitalstudies-subjects-grid',
    props: ['digitalstudiesdisciplines'],
    data() {
        return {
            disciplineButtons: {},
            domains: {},
            loading: false,
            clickedButtonColor: '',
        };
    },
    beforeMount() {
        this.disciplineButtons = this.digitalstudiesdisciplines.map((discipline) => {
            return {
                color: discipline.color,
                id: discipline.id,
                name: discipline.name,
                icon: discipline.icon_url,
            };
        });
    },
    methods: {
        showDomains(props, color) {
            this.clickedButtonColor = color;
            this.loading = true;
            this.axios.get(this.routes.digitalstudiesGetDomains(props)).then(
                (response) => {
                    const { domains } = response.data;
                    let selectedDomain = {};
                    let subDomains = {};

                    if (domains.length) {
                        this.domains = domains.map((domain) => {
                            selectedDomain = {
                                id: domain.id,
                                discipline_id: domain.discipline_id,
                                name: domain.name,
                                // videoCount: domain.videoCount,
                                color,
                            };

                            if (domain.sub_domains.length) {
                                subDomains = domain.sub_domains.map((subdomain) => {
                                    return {
                                        name: subdomain.name,
                                        id: subdomain.id,
                                        domainId: subdomain.domain_id,
                                        // videoCount: subdomain.relationships.video.data.length
                                    };
                                });
                            }

                            for (const button of this.disciplineButtons) {
                                if (selectedDomain.discipline_id === button.id) {
                                    selectedDomain.icon = button.icon;
                                    break;
                                }
                            }

                            selectedDomain = {
                                ...selectedDomain,
                                subDomains,
                            };

                            this.loading = false;

                            return selectedDomain;
                        });
                    }
                },
                (error) => {
                    this.alert.ajaxError(error, this.$t('digital_studies.error_retrieving_courses'));
                },
            );
        },

        btnStyle(button) {
            return {
                color: button.color,
            };
        },

        iconStyle(button) {
            return {
                fill: button.color,
            };
        },

        loadingStyle() {
            return {
                color: this.clickedButtonColor,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.discipline-buttons {
    margin-bottom: 60px;
}

.subdomain-loading {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.subdomain-loading .fas {
    font-size: 32px;
}

.discipline-buttons {
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.discipline-button {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    padding: map-get($grid-gutter-spacing, 'five') map-get($grid-gutter-spacing, 'twenty-one');
    background: $white;
    border: none;
    border-radius: 7px;
}

.discipline-button:hover {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.75);
}

.icon {
    height: 30px;
    width: 30px;
    margin-right: map-get($grid-gutter-spacing, 'ten');
}

.icon > svg {
    max-height: 30px;
}

.discipline-name {
    align-self: center;
    text-transform: capitalize;
}
</style>
